export default __webpack_public_path__ + "static/media/spotify.d5b9b54d.webp";